import "../../styles/NuevaReservacion.css";

const ProbiomedExtra = ({ value, onChange, options = [] }) => {
  return (
    <div className="form-group">
      <label htmlFor="probiomed-internal">
        Seleccione el almacén:
      </label>
      <select
        id="probiomed-internal"
        value={value}
        onChange={onChange}
      >
        <option value="">Seleccione una opción</option>
        {options.map((opcion) => (
          <option key={opcion.id} value={opcion.id}>
            {opcion.ubicacion}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProbiomedExtra;